/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {usePromotions} from '@salesforce/commerce-sdk-react'
import InformativeLabel from '../informative-label'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'

/**
 * In the context of a cart product item variant, this component renders a styled
 * list of the selected variation values as well as any promos (w/ info popover).
 */
const ItemCalloutMessages = ({product}) => {
    const {data: basket} = useCurrentBasket()

    const productPromotionIds = product?.priceAdjustments?.map((adj) => adj.promotionId) ?? []
    const orderPromotionIds = basket?.orderPriceAdjustments?.map((adj) => adj.promotionId) ?? []

    // Concatenate productPromotionIds and orderPromotionIds arrays and make it with unique values
    const allPromotionIds = [
        ...new Set([...productPromotionIds, ...orderPromotionIds].filter(Boolean)),
    ]

    // Fetch all the promotions given by price adjustments. We display this info in
    // informative labels
    const {data: res} = usePromotions(
        {parameters: {ids: allPromotionIds.join(',')}},
        {enabled: allPromotionIds.length > 0},
    )
    const promos = res?.data || []

    return (
        <>
            {allPromotionIds?.length > 0 &&
                promos?.map(
                    (promo, index) =>
                        promo?.calloutMsg && (
                            <InformativeLabel
                                key={index}
                                label={promo?.calloutMsg}
                                variant="coupon"
                            />
                        ),
                )}
        </>
    )
}

ItemCalloutMessages.propTypes = {
    product: PropTypes.object,
}

export default ItemCalloutMessages
